export const bookingData = [
  {
    _id: '658848715ad2604f697e534a',
    userId: '64930dfff9d66e79ba263490',
    name: 'single room only',
    email: 'rishabh5@mail.com',
    phone: 9876543210,
    specialRequest: 'dddd',
    roomDetails: [
      {
        id: '64b7f1f04da4b1a8c2e3adf8',
        count: 1,
        roomType: 'royal suite',
        name: 'single room only',
        price: 5000,
      },
    ],
    startDate: '2023-12-28T00:00:00.000Z',
    endDate: '2023-12-29T00:00:00.000Z',
    totalPrice: 5000,
    totalRooms: 1,
    date: '2023-12-24T15:04:17.105Z',
    __v: 0,
  },
  {
    _id: '658852b3a322cfc90e85bd84',
    name: 'rishabh',
    email: 'rishabh566@mail.com',
    phone: 9876543210,
    specialRequest: '',
    roomDetails: [
      {
        id: '64b7f1f04da4b1a8c2e3adf8',
        count: 1,
        roomType: 'royal suite',
        name: 'single room only',
        price: 5000,
      },
    ],
    startDate: '2024-01-14T00:00:00.000Z',
    endDate: '2024-01-15T00:00:00.000Z',
    totalPrice: 5000,
    totalRooms: 1,
    date: '2023-12-24T15:48:03.927Z',
    __v: 0,
  },
];
